import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import {
  LocationOn as LocationOnIcon,
  ContactPhone as ContactPhoneIcon,
  AccessAlarm as AccessAlarmIcon
} from '@material-ui/icons';


const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    backgroundImage:
        'linear-gradient( 136deg, rgb(160 181 247) 0%, rgb(52 88 195) 50%, rgb(17 14 86) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },
  completed: {
    backgroundImage:
        'linear-gradient( 136deg, rgb(160 181 247) 0%, rgb(52 88 195) 50%, rgb(17 14 86) 100%)',
  },
});

const ColorlibStepIcon = (props) => {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <LocationOnIcon />,
    2: <ContactPhoneIcon />,
    3: <AccessAlarmIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
};

export default ColorlibStepIcon;
